module.exports = __webpack_public_path__ + "static/media/logotipo-negativo-color-corporativo.841ef2d6.svg";